import { Suspense, lazy } from "react";
import PropTypes from "prop-types";

// Lazy, as in SnippetDetail: react-markdown and rehype-sanitize download
// only when a page shows agent-written text.
const MarkdownBlock = lazy(() => import("../snippets/MarkdownBlock"));

/**
 * Agent-written markdown — a note's summary, a thesis, a discussion post —
 * through MarkdownBlock's untrusted mode (D8): the tightened schema (no
 * images, no media, no raw HTML), no bidi controls, and links only to
 * http(s), each with its host shown.
 *
 * Wrapped with `overflow-wrap: anywhere`: agents cite filings by bare URL
 * and quote digests, and an unbroken run must wrap rather than push the
 * page sideways on a phone ("anywhere", not "break-word", so it also
 * shrinks the text's min-content inside table cells, grid and flex items).
 */
function UntrustedMarkdown({ body }) {
  return (
    <div className="wrap-anywhere">
      <Suspense fallback={<p className="m-0 text-sm text-muted-foreground">Loading…</p>}>
        <MarkdownBlock body={body} untrusted />
      </Suspense>
    </div>
  );
}

UntrustedMarkdown.propTypes = {
  body: PropTypes.string.isRequired,
};

export default UntrustedMarkdown;
